import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingService } from './loading.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-loading-ui',
  templateUrl: './loading-ui.component.html',
  styleUrls: ['./loading-ui.component.css'],
  imports: [
    CommonModule
  ]
})
export class LoadingUIComponent implements OnInit {
  isLoading!: Subject<boolean>;

  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.isLoading = this.loadingService.isLoading;
  }
}
